import axios from "axios";
import {
  CreateReportBodyRequest,
  UpdateAlternativeEmailRecordParams,
} from "../../types/services/salesforce";

const createSalesForceRecord = async ({
  avarageDepth,
  diameter,
  length,
  width,
  poolLocation,
  season,
  postCode,
  big,
  small,
  city,
  electricityCost,
  email,
  name,
  operationHours,
  poolMaterial,
  poolShape,
  poolType,
  requiredPoolTemp,
  standardPumpCapacity,
  premiumPumpCapacity,
  state,
  existingPool,
  surfaceArea,
  temperaturePerMonth,
  totalPricePremium,
  totalPriceStandart,
  volume,
  withCover,
  token,
}: CreateReportBodyRequest): Promise<any> => {
  const url =
    process.env.REACT_APP_ENVIRONMENT === "production"
      ? `https://gjhcrzcq7k.execute-api.ap-southeast-2.amazonaws.com/hc-prod/report`
      : `https://j54tq8cxdl.execute-api.ap-southeast-2.amazonaws.com/hc-uat/report`;

  try {
    const response = await axios.post(url, {
      avarageDepth,
      diameter,
      length,
      postCode,
      width,
      poolLocation,
      season,
      big,
      small,
      city,
      electricityCost,
      email,
      name,
      operationHours,
      existingPool,
      poolMaterial,
      poolShape,
      poolType,
      requiredPoolTemp,
      standardPumpCapacity,
      premiumPumpCapacity,
      state,
      surfaceArea,
      temperaturePerMonth,
      totalPricePremium,
      totalPriceStandart,
      volume,
      withCover,
    });
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching access token:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

const sendPDF = async ({
  pdfBase64,
  reportId,
}: {
  pdfBase64: string;
  reportId: string;
}) => {
  const url =
    process.env.REACT_APP_ENVIRONMENT === "production"
      ? `https://gjhcrzcq7k.execute-api.ap-southeast-2.amazonaws.com/hc-prod/pdf`
      : `https://j54tq8cxdl.execute-api.ap-southeast-2.amazonaws.com/hc-uat/pdf`;

  try {
    const response = await axios.post(url, {
      reportId,
      pdfBase64,
    });
    return response.data;
  } catch (error: any) {
    console.error(
      "Error sending PDF:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

const updateSalesForceAlternativeEmailRecord = async ({
  alternativeEmail,
  alternativeName,
  email,
  reportId,
  sendAlternativeEmail,
  sendEmail,
}: UpdateAlternativeEmailRecordParams) => {
  const url =
    process.env.REACT_APP_ENVIRONMENT === "production"
      ? `https://gjhcrzcq7k.execute-api.ap-southeast-2.amazonaws.com/hc-prod/update`
      : `https://j54tq8cxdl.execute-api.ap-southeast-2.amazonaws.com/hc-uat/update`;

  const body = {
    alternativeEmail,
    alternativeName,
    email,
    reportId,
    sendAlternativeEmail,
    sendEmail,
  };

  try {
    const response = await axios.patch(url, body);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching access token:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const salesforceService = {
  createSalesForceRecord,
  updateSalesForceAlternativeEmailRecord,
  sendPDF,
};
